import React, { FC } from 'react';
import { UploadFileWithAttachment } from 'api/attachments';
import { AttachmentImage } from 'components/molecules/attachment-image';
import { ProjectResource } from 'hooks/rbac/useWithAccess';

type AttachmentProps = {
  file: UploadFileWithAttachment;
  onRemoveFile(file: UploadFileWithAttachment): void;
  onDownloadFile?(file: UploadFileWithAttachment): void;
  large?: boolean;
  isBasicPreview?: boolean;
  projectResource?: ProjectResource;
};

export const Attachment: FC<AttachmentProps> = ({
  file,
  onRemoveFile,
  onDownloadFile,
  large,
  isBasicPreview,
  projectResource,
}) => {
  return (
    <AttachmentImage
      originFileObj={file.originFileObj}
      fileUid={file.uid}
      fileUploadStatus={file.status}
      name={file.name}
      attachmentId={file.attachment?.attachmentId}
      thumbUrl={file.thumbUrl}
      url={file.url}
      onRemove={() => onRemoveFile(file)}
      onDownload={() => onDownloadFile?.(file)}
      large={large}
      showCustomPreview
      isBasicPreview={isBasicPreview}
      isAnnotationStarted={file.attachment?.isAnnotationStarted}
      isVersionAvailable={file.attachment?.versionsAvailable}
      projectResource={projectResource}
    />
  );
};
